import { Link } from 'react-router-dom';
import VideoCard from './VideoCard';
import type { VideoItem } from '@/mocks/videos';

interface VideoGridProps {
  title: string;
  subtitle?: string;
  videos: VideoItem[];
  linkTo?: string;
}

export default function VideoGrid({ title, subtitle, videos, linkTo }: VideoGridProps) {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-12">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
              {title}
            </h2>
            {subtitle && (
              <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>
            )}
          </div>
          {linkTo && (
            <Link
              to={linkTo}
              className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1 whitespace-nowrap"
            >
              查看全部
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </Link>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 md:gap-4">
          {videos.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              thumbnail={video.thumbnail}
              rating={video.rating}
              year={video.year}
              duration={video.duration}
              tags={video.tags}
              views={video.views}
              isHot={video.isHot}
              isNew={video.isNew}
            />
          ))}
        </div>
      </div>
    </section>
  );
}